// Version : 1.0.0
// Author : AGALYA
import { takeLatest, put, all, call } from 'redux-saga/effects';
import CurrentAddressActionType from './current-address.types';
import {
	currentAddressAddSuccess,
	currentAddressAddFailure,
	currentAddressAddUserResponseChanged,
} from './current-address.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { currentMemberAddressAdd } from './current-address.service';

//** ***************** CURRENT ADDRESS ADD START *********************** */
export function* AddCurrentAddress({ payload }: any) {
	try {
		const key = 'AddMemberCurrentAddress';
		const {
			companyID,
			databaseName,
			memberID,
			pincode,
			doorNo,
			addressStreet,
			country,
			state,
			district,
			city,
			village,
			since,
			userID,
			postOffice,
			sameForCurrent,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberCurrentPinCode: pincode,
			MemberCurrentDoorNo: doorNo,
			MemberCurrentAddressStreet: addressStreet,
			MemberCurrentCountry: country,
			MemberCurrentState: state,
			MemberCurrentDistrict: district,
			MemberCurrentCity: city,
			MemberCurrentLocalArea: village,
			MemberCurrentSinceYr: since,
			OfficerID: userID,
			Secratekey: key,
			MemberCurrentPostOffice: postOffice,
			SameAsResident: sameForCurrent,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(currentMemberAddressAdd, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(currentAddressAddFailure(responseData.data));
		} else {
			yield put(currentAddressAddSuccess(responseData.data));
		}
	} catch (error) {
		yield put(currentAddressAddFailure(error));
	}
}

export function* AddCurrentAddressResponseClear() {
	yield put(currentAddressAddUserResponseChanged());
}

export function* onCurrentAddressAddStart() {
	yield takeLatest(CurrentAddressActionType.CURRENT_ADDRESS_ADD_START, AddCurrentAddress);
}

export function* onCurrentAddressAddResponseRest() {
	yield takeLatest(
		CurrentAddressActionType.CURRENT_ADDRESS_ADD_RESPONSE_REST_START,
		AddCurrentAddressResponseClear,
	);
}
//** ***************** CURRENT ADDRESS ADD END *********************** */

export function* currentAddressSaga() {
	yield all([call(onCurrentAddressAddStart), call(onCurrentAddressAddResponseRest)]);
}
